import { createSlice } from '@reduxjs/toolkit'

const courseDetailsStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: courseDetailsStatus.LOADING,
    courseDetails: {
        objectives: [],
        lessons: [],
    },
    errorMessage: null,
}

const courseDetailsSlice = createSlice({
    name: 'courseDetails',
    initialState,
    reducers: {
        getCourseDetailsRequest: state => {
            state.status = courseDetailsStatus.LOADING
        },
        getCourseDetailsRequestSuccess: (state, action) => {
            state.status = courseDetailsStatus.SUCCESS
            let courseObj = action.payload
            courseObj.objectives = courseObj.objectives.split(';')
            state.courseDetails = courseObj
        },
        getCourseDetailsRequestError: (state, action) => {
            state.status = courseDetailsStatus.FAILURE
            state.errorMessage = action.payload
        },
        reset: _ => ({
            ...initialState,
        }),
    },
})

const {
    getCourseDetailsRequest,
    getCourseDetailsRequestSuccess,
    getCourseDetailsRequestError,
    reset,
} = courseDetailsSlice.actions

export const courseDetailsActions = {
    getCourseDetailsRequest,
    getCourseDetailsRequestSuccess,
    getCourseDetailsRequestError,
    reset,
}

export const courseDetailsSelectors = {
    isFetching: state =>
        state.courseDetails.status === courseDetailsStatus.LOADING,
    hasError: state =>
        state.courseDetails.status === courseDetailsStatus.FAILURE,
    success: state =>
        state.courseDetails.status === courseDetailsStatus.SUCCESS,
    errorMessage: state => state.courseDetails.errorMessage,
    courseDetails: state => state.courseDetails.courseDetails,
}

const courseDetailsReducer = courseDetailsSlice.reducer

export default courseDetailsReducer
